<template lang="pug">
  a.tw(:class='lang', target=' _blank', :href='comment')
    img#gshare_tw(alt='twitter', target=' _blank', width='28', height='28', src='images/btn_share_tw.png')

</template>
<script>
  import {mapState} from 'vuex';

  export default {
    data: function(){
      return {
        path: 'https://twitter.com/intent/tweet?text=',
        ja_text: '「データの“可視化”を通じて、日本が抱える保健医療の課題と解決策を明らかにします」\n' +
        'MeditechFinder - http://meditechfinder.org/',
        en_text: '"Meditech Finder enables you to visualize Japan\'s health challenges and opportunities for reform."\n' +
        '- http://meditechfinder.org/en/'
      }
    },
    computed: {
      ...mapState([
        'lang',
      ]),
      comment: function(){
        if(/ja/.test(this.lang)){
          return this.path + this.ja_text;
        }else{
          return this.path + this.en_text;
        }
      },

    }
  }
</script>